import React from 'react';
import { Autocomplete } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ExpandMore } from '@mui/icons-material';
import { menuItemStyles } from '../MenuItem/MenuItem';
import { menuListStyles } from '../Menu/Menu';

const style = {
  listbox: menuListStyles,
  option: menuItemStyles,
};

export const CustomizedAutocomplete = withStyles(style)(Autocomplete);

export default function (props) {
  return <CustomizedAutocomplete popupIcon={<ExpandMore />} {...props} />;
}
